/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-documents
 * crm-screener-documents
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EnqueueGenerateReport200Response,
  ScreenerGeneratedDocumentType,
} from '../models/index';
import {
    EnqueueGenerateReport200ResponseFromJSON,
    EnqueueGenerateReport200ResponseToJSON,
    ScreenerGeneratedDocumentTypeFromJSON,
    ScreenerGeneratedDocumentTypeToJSON,
} from '../models/index';

export interface EnqueueGenerateReportRequest {
    leadId: string;
    reportType: ScreenerGeneratedDocumentType;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Only supports PCC-sourced report types (pcc_face_sheet_report, pcc_order_summary_report, pcc_md_history_report) — generation for every other type happens fast enough that the synchronous GET endpoint on crm-screener still applies. Returns immediately; poll ListGeneratedReports or GetGeneratedReportDownloadUrl for the result. 
     * Enqueue asynchronous generation of a PCC-sourced report
     */
    async enqueueGenerateReportRaw(requestParameters: EnqueueGenerateReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EnqueueGenerateReport200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling enqueueGenerateReport.');
        }

        if (requestParameters.reportType === null || requestParameters.reportType === undefined) {
            throw new runtime.RequiredError('reportType','Required parameter requestParameters.reportType was null or undefined when calling enqueueGenerateReport.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/generated-reports/{report_type}`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))).replace(`{${"report_type"}}`, encodeURIComponent(String(requestParameters.reportType))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EnqueueGenerateReport200ResponseFromJSON(jsonValue));
    }

    /**
     * Only supports PCC-sourced report types (pcc_face_sheet_report, pcc_order_summary_report, pcc_md_history_report) — generation for every other type happens fast enough that the synchronous GET endpoint on crm-screener still applies. Returns immediately; poll ListGeneratedReports or GetGeneratedReportDownloadUrl for the result. 
     * Enqueue asynchronous generation of a PCC-sourced report
     */
    async enqueueGenerateReport(requestParameters: EnqueueGenerateReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EnqueueGenerateReport200Response> {
        const response = await this.enqueueGenerateReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
